module.exports = "https://s91588.cdn.ngenix.net/cs-frontend-v2/_next/static/images/coin_left-c91690954ecb859516ddf0fd8508be7b.png";